import { render, staticRenderFns } from "./res-view.vue?vue&type=template&id=4274d646&scoped=true&"
import script from "./res-view.vue?vue&type=script&lang=js&"
export * from "./res-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4274d646",
  null
  
)

export default component.exports